import React, {useEffect} from "react";
import {Field, Formik} from "formik";
import {AEButton} from "../../../../../_emywork/components/buttons";
import {AEAutoComplete, AEDatePicker, AEInput} from "../../../../../_metronic/_partials/controls";
import {AESVG} from "../../../../../_emywork/components/svg";
import {ButtonGroup, Dropdown} from "react-bootstrap";
import {useIntl} from "react-intl";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {fetchEntities as getCategories} from "../../../Categories/_redux/actions";
import {actionTypes as categoriesActionTypes} from "../../../Categories/_redux/slice";
import {localField} from "../../../../../_emywork/helpers/UIHelper";


const initValues = {
  search: "",
  category_id: undefined,
  created_at: undefined,
  updated_at: undefined,

}

export function Filter({ filters,  setFilters, setSearch, setCreatedAt, ...props }) {
  const {formatMessage} = useIntl()
  const dispatch = useDispatch();
  const {categories, meta, isLoading} = useSelector(state=> {
    const {entities, meta, isLoading} = state.categories[categoriesActionTypes.LocationFilterList]
    return {
      categories:entities,
      meta, isLoading
    }
  },shallowEqual)
  //
  // const formikRef = useRef()
  // if (formikRef && formikRef.current) {
  //   formikRef.current.setFieldValue('category_id',2)
  //
  // }

  useEffect(()=>{
    dispatch(getCategories(meta, categoriesActionTypes.LocationFilterList))
  }, [dispatch])





  return (
    <>
      <Formik
        enableReinitialize
        // innerRef={formikRef}
        initialValues={initValues}
        onSubmit={(values) => {
          // console.log(values)
          values.category_id = values.category_id || undefined
          setFilters(values)
        }}
      >
        {({ handleSubmit, resetForm, setFieldValue, values }) => (
          <form className="row d-flex justify-content-end">
            <div className={"col-lg-3 px-2"}>
              <Field
                name={"search"}
                component={AEInput}
                validation={false}
                label={'SEARCH'}
                withFeedbackLabel={false}
              />
            </div>
            <div className={"col-lg-3 px-2"}>
              <Field
                name={"category_id"}
                component={AEAutoComplete}
                useId
                options={categories}
                getOptionLabel={o=> o[localField('name')]}
                label={'CATEGORY'}
                withFeedbackLabel={false} validation={false}
              />

            </div>
            <div className={"col-lg-2 px-2"}>
              <Field
                type={'date'}
                name={"created_at"}
                component={AEDatePicker}
                validation={false}
                label='CREATED_AT'
                // shrinkLabel
                withFeedbackLabel={false}
              />
            </div>
            <div className={"col-lg-2 px-2"}>
              <Field
                type={'date'}
                name={"updated_at"}
                component={AEDatePicker}
                validation={false}
                label='UPDATED_AT'
                // shrinkLabel
                withFeedbackLabel={false}
              />
            </div>
            <div className={""}>
              <Dropdown as={ButtonGroup}>
                <AEButton variant={"light"} fontWeight={"bolder"} onClick={handleSubmit}>
                  <AESVG path={"/Navigation/Check.svg"} variant={"primary"}/>
                  {formatMessage({id:"APPLY"})}
                </AEButton>
                <Dropdown.Toggle split variant="light" />
                <Dropdown.Menu className={"py-5"}>
                  <Dropdown.Item onClick={() => {resetForm(); handleSubmit();}}>
                    {/*<AESVG path={"/General/Update.svg"} variant={"primary"} className={"pr-3"}/>*/}
                    {formatMessage({id:"RESET"})}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </form>

        )}
      </Formik>

    </>
  );
}
